<template>
  <vue-phone-number-input
    v-model="phone"
    :translations="{
      countrySelectorLabel: $t('field.customer.country_code'),
      countrySelectorError: $t('field.customer.country'),
      phoneNumberLabel: $t('field.customer.phone_number'),
      example: $t('field.customer.example')
    }"
    :default-country-code="defaultCountryCode"
    :disabled="disabled"
    :required="required"
    clearable
    @update="onUpdate"
  />
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
  name: 'VPhoneInput',

  components: {
    VuePhoneNumberInput
  },

  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },

  data () {
    return {
      phone: this.value,
      defaultCountryCode: 'FR'
    }
  },

  watch: {
    phone(newPhone) {
      if (!newPhone) return
      const parsedPhone = parsePhoneNumberFromString(newPhone)
      if (parsedPhone) {
        this.defaultCountryCode = parsedPhone.country
      }
    }
  },

  methods: {
    onUpdate (phone) {
      if (phone.isValid) {
        this.$emit('input', phone.formatInternational)
        this.updateCountryCode(phone.formatInternational)
      } else {
        this.$emit('input', null)
      }
    },
    updateCountryCode (phoneNumber) {
      const parsedPhone = parsePhoneNumberFromString(phoneNumber)
      if (parsedPhone) {
        this.defaultCountryCode = parsedPhone.country
      }
    },
    focus () {
      const els = document.getElementsByClassName('input-tel__input')
      if (els.length > 0) els[0].focus()
    }
  }
}
</script>
